<div class="relative">
  <ng-content></ng-content>
</div>
